import { gatewayApi as api } from './gatewayApi';

export interface ShipTo {
  Id?: number;
  AttName: string;
  AttSt: string;
  AttApt: string;
  AttCity: string;
  AttState: string;
  AttZIP: string;
  AttPhone: string;
  AttEmail: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface ShipToListResponse {
  data: ShipTo[];
  total: number;
}

export interface ShipToSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  city?: string;
  state?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const shipToApi = {
  getAll: (params?: ShipToSearchParams): Promise<ShipToListResponse> =>
    api.get('/shipto', params),

  getById: (id: number): Promise<ShipTo> =>
    api.get(`/shipto/${id}`),

  create: (item: Omit<ShipTo, 'Id'>): Promise<ShipTo> =>
    api.post('/shipto', item),

  update: (id: number, item: Partial<ShipTo>): Promise<ShipTo> =>
    api.put(`/shipto/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/shipto/${id}`),

  search: (params: ShipToSearchParams): Promise<ShipToListResponse> =>
    api.post('/shipto/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/shipto/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/shipto/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/shipto/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/shipto/statistics'),

  exportToCSV: (params?: ShipToSearchParams): Promise<Blob> =>
    api.getBlob('/shipto/export', { params }),

  validation: {
    validate: (item: Partial<ShipTo>): string[] => {
      const errors: string[] = [];
      if (!item.AttName || item.AttName.trim().length === 0) errors.push('Name is required');
      if (!item.AttSt || item.AttSt.trim().length === 0) errors.push('Street is required');
      if (!item.AttCity || item.AttCity.trim().length === 0) errors.push('City is required');
      if (!item.AttState || item.AttState.trim().length === 0) errors.push('State is required');
      if (!item.AttZIP || item.AttZIP.trim().length === 0) errors.push('ZIP is required');
      if (!item.AttPhone || item.AttPhone.trim().length === 0) errors.push('Phone is required');
      if (!item.AttEmail || item.AttEmail.trim().length === 0) errors.push('Email is required');
      if (item.Active === undefined || item.Active === null) errors.push('Active status is required');
      return errors;
    },
  },
};

export default shipToApi; 